import Devarajan from "../assets/ceos/Devarajan.png";
import Anup from "../assets/ceos/Anup.jpeg";
import Manish from "../assets/ceos/Manish.png";
import Shripad from "../assets/ceos/Shripad.png";
import Tapobrat from "../assets/ceos/Tapobrat.jpg";
import Shwetha from "../assets/ceos/Shwetha.png";
import AshutoshImage from "../assets/leadership team/ashutosh-chaturvedi.jpg";
import TarandeepImage from "../assets/leadership team/tarandeep-singh.png";
import TarunImage from "../assets/leadership team/tarun-srivstava.jpg";
import AnkurImage from "../assets/leadership team/ankur-agarwal.jpg";
import AnjaliImage from "../assets/leadership team/anjali-manwani.jpg";
import ShyamImage from "../assets/leadership team/shyam-kanhaiya.jpg";
import SPImage from "../assets/leadership team/S. Panchakshari.jpg";
import VinayPratapImage from "../assets/leadership team/Vinay Pratap Singh.jpeg";
import AshishSinghImage from "../assets/leadership team/Ashish Singh.jpeg";
import MdSaifImage from "../assets/leadership team/Md. Saif Khan.jpeg";
import AnilGuptaImage from "../assets/leadership team/Anil Gupta.jpeg";
import NihalImage from "../assets/leadership team/Nihal sir.jpg";
import ParthaImage from "../assets/leadership team/partha sir photo.png";
import PradapImage from "../assets/leadership team/Pradap RST.jpg";
import UttamImage from "../assets/leadership team/Uttam Dhiran.PNG";
import ManishRajImage from "../assets/leadership team/Manish Raj, Chief Accounts Controller.jpeg";
import LekshmiImage from "../assets/leadership team/lekshmi mam.png";
import NehaImage from "../assets/leadership team/neha.jpeg";
import SanjeevShuklaImage from "../assets/leadership team/sanjeev-shukla.jpeg";
import AnkitTyagiImage from "../assets/leadership team/Ankit sir.jpg";
import RadhaImage from "../assets/leadership team/radha.png";
import ChandrashekarImage from "../assets/leadership team/Chandrashekar H.P.png";
import VivekPlanningImage from "../assets/leadership team/Vivek Srivastava, Chief-Planning & Monitoring.jpeg";
import SantoshSurveImage from "../assets/leadership team/Santosh Surve Head IT Products.jpeg";
import RajeshSinhaImage from "../assets/leadership team/Rajesh Sinha, Learning & Development Head.jpg";
import RahulChatterjeeImage from "../assets/leadership team/Rahul Chatterjee1.jpg";
import GuruprasathImage from "../assets/leadership team/Guruprasath(Internal Audit Head).jpeg";
export const aboutData = {
  page: [
    {
      title: "Journey",
      sections: [
        {
          id: 4,
          heading: "Journey",
          content:
            "MFIN is the first Self-Regulatory Organisation (SRO) in the financial services sector recognized by the RBI and regulates NBFC-MFIs to ensure responsible lending and client protection. MFIN works closely with other key stakeholders and plays an active part in the larger financial inclusions dialogue through the medium of microfinance. MFIN's vision of promoting inclusive growth drives our Advocacy efforts. We engage with diverse stakeholders. MFIN's Development Initiatives aid robust development of the sector.",
          image: "mfin",
        },
      ],
    },
    {
      title: "About",
      sections: [
        {
          id: 1,
          heading: "BSS SONATA MICROCREDIT LTD.",
          content:
            "BSS Sonata facilitates microcredit on behalf of Kotak Mahindra Bank Ltd. (KMBL), aiming to make microfinance financially self-sustainable. By leveraging structured processes, advanced technology, and focused training, we ensure the consistent delivery of high-quality services to KMBL’s microcredit borrowers.<br/> The Company distributes small loans that begin at Rs. 2,000 to Rs. 1,00,000 to poor women so they can start and expand simple businesses and increase their incomes.",
          subData: [
            {
              id: 1,
              subTitle: "LOAN SERVICES",
              content:
                "Loan is repayable by weekly, fornightly & monthly installments at the choice of the borrower. The repayment of credit facilitated by the company is repayable in weekly, fornightly & monthly installments at the choice of the borrower.",
              icon: "GoLightBulb",
            },
            {
              id: 2,
              subTitle: "YEAR OF EXPERTISE",
              content:
                "BSS SONATA has combined experience of more than 36 years in Financial Services sector.",
              icon: "LiaMedalSolid",
            },
          ],
          image: "https://sonataindia.com/imgaes/Grp1.jpg",
        },
      ],
    },
    {
      title: "Mission & Vision",
      sections: [
        {
          id: 2,
          heading: "Vision",
          content:
            "To see a financially inclusive society where every woman has the opportunity and access to resources to realize her full potential and to shape a better future — living a life of dignity, hope, and prosperity.",
          image: "",
        },
        {
          id: 1,
          heading: "Mission",
          content:
            "To transform lives by empowering women through access to fair, transparent, and timely financial services in a cost-effective manner. <br><br>We strive to nurture aspirations, strengthen families, and build thriving communities — guided by integrity, compassion, and a deep commitment to inclusive growth and social progress.",
          image: "",
        },
      ],
    },
    {
      title: "Board of Directors",
      sections: [
        {
          name: "Devarajan Kannan ",
          role: "Director and Chairman",
          image: Devarajan,
          title: "Director and Chairman",
          paragraphs: [
            "In his little more than three decades at Kotak Mahindra Group, D Kannan has spearheaded various businesses. In 1991, he joined Kotak Mahindra Finance Ltd. as Assistant Manager. Thereafter, he was elevated to Vice President - Field Operation, Ford Credit Kotak Mahindra Ltd. with the responsibility of its Sales & Marketing functions.",
            "Kannan moved to Kotak Securities Ltd in 2000. He set up kotaksecurities.com - the online trading and stock market advisory platform of the retail brokerage business. Prior to taking charge of the Commercial Banking business, Kannan was Managing Director (MD), Kotak Securities Ltd. Prior to his elevation as MD of Kotak Securities, he was the company’s Executive Director.",
            "Kannan was heading one of the Strategic Business Units (SBU) of Kotak Mahindra Bank - the Commercial Banking business from August 2014 to July 2022. Kannan was part of the Bank’s Group Management Council that drives and oversees Kotak Mahindra Group’s growth charter.",
            "Mr.Devarajan is a commerce graduate from Bangalore University, Chartered Accountant(CA), and Cost and Works Accountant(CWA).",
          ],
        },
        {
          name: "Anup Kumar Singh ",
          role: "Managing Director & Chief Executive Officer",
          image: Anup,
          title: "Technical Mastery",
          paragraphs: [
            "Mr. Anup Kumar Singh, a pioneer in India’s microfinance sector with over 28 years of rich experience, has been appointed as the Managing Director and CEO of BSS Sonata Microcredit Limited, following the merger of Sonata Finance Private Limited under BSS Microfinance Limited.",
            "Mr. Singh, who founded Sonata Finance in 2006, has been instrumental in transforming it into one of Uttar Pradesh’s leading microfinance institutions through his visionary leadership and deep commitment to financial inclusion.",
            "With extensive training from the renowned Grameen Bank in Bangladesh and academic credentials including a Master’s in Economics & Sociology, a Postgraduate Diploma in Rural Development and Management, and an MBA in Finance, Mr. Singh brings a unique blend of expertise and empathy to his role. He now envisions steering BSS Sonata Microcredit Limited toward becoming a one-stop solution for customers’ financial needs—strengthening its position as a trusted financial counsellor and enabler of socio-economic empowerment for millions.",
          ],
        },
        {
          name: "Manish Kothari",
          role: "Director",
          image: Manish,
          title: "Growth Drivers",
          paragraphs: [
            "Manish has been with Kotak Mahindra Bank for close to 3 decades & has been a part of Kotak Leadership Team (KLT) for the last 15 years. He took charge as the President & Head - Commercial Banking in August 2022 and he currently heads a 11,000+ strong team across India covering multiple segments, viz., Agri Business – MSME & Corporates; Rural – Tractor & Crop Loans; Logistics and Infra – CV, CE Loans and Working Capital; Inclusion – Microcredit and Gold Loans.",
            "Prior to this role, Manish led the Corporate Banking business of the Bank where he played a key role in setting up the Bank’s franchise in all customer segments of Corporate Banking, viz., Conglomerates, Large Corporates, Mid Corporates, SMEs, E-Commerce/Start-ups (New Age Cos.), Credit Light Corporates and Supply Chain of Corporates.",
            "He is a metallurgical engineering graduate from the Visvesvaraya National Institute of Technology, Nagpur where he topped the University. He has completed his PGDBM from XLRI, Jamshedpur, specializing in both Finance & Marketing.",
          ],
        },
        {
          name: "Tapobrat Chaudhuri",
          role: "Director",
          image: Tapobrat,
          title: "Growth Drivers",
          paragraphs: [
            "Tapobrat Chaudhuri heads the Microfinance business of Kotak Mahindra Bank and has an experience of more than 2 decades in banking. He joined the Kotak group in 2005 in the Agri Business Group of the Bank and has worked in various roles before becoming the National Sales Manager in Corporate Agri Business. In this role he has handled & nurtured marquee relationships of companies in the Food & Agri sector. As a natural expansion of Kotak Bank’s operations into the rural & semi-urban economy he built deep relationships with microfinance companies & NBFCs.",
            "In his current role, his core responsibility is to strengthen & expand the retail microfinance franchise of Kotak with an objective of fostering financial inclusion while at the same time building a scalable and profitable business. He has tested skills of building, coordinating and leading teams. He is an ardent believer in the transformational role of technology in exponentially scaling up operations. He has actively worked with MFIN in various policy matters related to microfinance and was on MFIN’s task force on drafting of the Code of Responsible Lending.",
            "Tapobrat started his career as a probationary officer in the State Bank of India group and also had a stint with Axis Bank before joining the Kotak group. He is a science graduate and a Certified Associate of the Indian Institute of Bankers (CAIIB).",
          ],
        },
        {
          name: "Shwetha Kalappa ",
          role: "Director",
          image: Shwetha,
          paragraphs: [
            "Shwetha Kalappa is a Talent Engagement Champion with over two decades of expertise in balancing strategic intent with operational excellence. She has extensive experience in the BFSI sector having lead the integration of people, process and technology of HR in two of the biggest mergers in the industry. Has led the various facets of HR as COE, Business Partner and Shared Services. Adept at leading global projects, currently lead the employee experience, and HR digital transformation journey across Kotak Mahindra Bank.",
            "As HR Automation Head - oversee the strategy and implementation of all IT transformation projects in HR. - Worklife App, K Applaud & Eureka are some properties launched and had 80% adoption within 3 months.",
            "As Employee Engagement Head several programs launched as flagship programs – Young Leader Council, Health & Wellness-Fitness Allowance. Kotakathon to engage employees deliver innovative solutions to enhance customer experience, Infinity Awards, Foundation Day event saw 25000 in audience in a virtual event. Wellness & Covid Support programs across group.",
            "Led the HR process, policy and people integration from ING during merger with Kotak.",
          ],
        },
       
      ],
    },
    {
      title: "Leadership Team",
      sections: [
        // {
        //   dept: "Business Team",
        //   chief: {
        //     id: 1,
        //     name: "S. Panchakshari",
        //     role: "Business Head",
        //     image: SPImage,
        //     details: "Details coming soon.",
        //   },
        //   members: [
        //     {
        //       id: 2,
        //       name: "S. Panchakshari",
        //       role: "Business Head",
        //       image: SPImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 3,
        //       name: "Vinay Pratap Singh",
        //       role: "Business Head",
        //       image: VinayPratapImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 4,
        //       name: "Ashish Singh",
        //       role: "Business Head",
        //       image: AshishSinghImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 5,
        //       name: "Md. Saif Khan",
        //       role: "Business Head",
        //       image: MdSaifImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 6,
        //       name: "Nehal Shah",
        //       role: "Business Head",
        //       image: NihalImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 7,
        //       name: "Partha Mukherjee",
        //       role: "Business Head",
        //       image: ParthaImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 8,
        //       name: "Anil Gupta",
        //       role: "Business Head",
        //       image: AnilGuptaImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 9,
        //       name: "Tarandeep Singh",
        //       role: "Business Head",
        //       image: TarandeepImage,
        //       details: "Details coming soon.",
        //     },
        //   ],
        // },
        {
          dept: "Finance and Accounts",
          chief: {
            id: 10,
            name: "Uttam Dhiran",
            role: "Chief Financial Officer",
            image: UttamImage,
            details: "Details coming soon.",
          },
          members: [
            {
              id: 11,
              name: "Uttam Dhiran",
              role: "Chief Financial Officer",
              image: UttamImage,
              details: "Details coming soon.",
            },
            // {
            //   id: 12,
            //   name: "Manish Raj",
            //   role: "Chief Accounts Controller",
            //   image: ManishRajImage,
            //   details: "Details coming soon.",
            // },
          ],
        },
        // {
        //   dept: "HR and L&D",
        //   chief: {
        //     id: 13,
        //     name: "Lekshmi Bhargavi",
        //     role: "HR Head",
        //     image: LekshmiImage,
        //     details: "Details coming soon.",
        //   },
        //   members: [
        //     {
        //       id: 14,
        //       name: "Lekshmi Bhargavi",
        //       role: "HR Head",
        //       image: LekshmiImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 15,
        //       name: "Neha Singh",
        //       role: "HR Head",
        //       image: NehaImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 16,
        //       name: "Rajesh Sinha",
        //       role: "Learning & Development Head",
        //       image: RajeshSinhaImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 17,
        //       name: "Rahul Chatterjee",
        //       role: "Learning & Development Head",
        //       image: RahulChatterjeeImage,
        //       details: "Details coming soon.",
        //     },
        //   ],
        // },
        // {
        //   dept: "Technology",
        //   chief: {
        //     id: 18,
        //     name: "Pradap RST",
        //     role: "Chief Technology Officer",
        //     image: PradapImage,
        //     details: "Details coming soon.",
        //   },
        //   members: [
        //     {
        //       id: 19,
        //       name: "Pradap RST",
        //       role: "Chief Technology Officer",
        //       image: PradapImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 20,
        //       name: "Ashutosh Chaturvedi",
        //       role: "Chief Information Officer",
        //       image: AshutoshImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 21,
        //       name: "Shyam Kanhaiya",
        //       role: "IT Head",
        //       image: ShyamImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 22,
        //       name: "Santosh Surve",
        //       role: "Head - IT Products",
        //       image: SantoshSurveImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 23,
        //       name: "Sunjiv Shukla",
        //       role: "IT Head",
        //       image: SanjeevShuklaImage,
        //       details: "Details coming soon.",
        //     },
        //   ],
        // },
        // {
        //   dept: "Internal Audit",
        //   chief: {
        //     id: 24,
        //     name: "Tarun Srivastava",
        //     role: "Internal Audit Head",
        //     image: TarunImage,
        //     details: "Details coming soon.",
        //   },
        //   members: [
        //     {
        //       id: 25,
        //       name: "Tarun Srivastava",
        //       role: "Internal Audit Head",
        //       image: TarunImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 26,
        //       name: "Guruprasath",
        //       role: "Internal Audit Head",
        //       image: GuruprasathImage,
        //       details: "Details coming soon.",
        //     },
        //   ],
        // },
        {
          dept: "Legal & Secretarial",
          chief: {
            id: 27,
            name: "Ankur Agarwal",
            role: "Chief Compliance Officer",
            image: AnkurImage,
            details: "Details coming soon.",
          },
          members: [
            {
              id: 28,
              name: "Ankur Agarwal",
              role: "Chief Compliance Officer",
              image: AnkurImage,
              details: "Details coming soon.",
            },
            {
              id: 29,
              name: "Anjali Manwani",
              role: "Company Secretary",
              image: AnjaliImage,
              details: "Details coming soon.",
            },
          ],
        },
        // {
        //   dept: "Process & Policies",
        //   chief: {
        //     id: 30,
        //     name: "Ankit Tyagi",
        //     role: "Head - Process and Policies",
        //     image: AnkitTyagiImage,
        //     details: "Details coming soon.",
        //   },
        //   members: [
        //     {
        //       id: 31,
        //       name: "Ankit Tyagi",
        //       role: "Head - Process and Policies",
        //       image: AnkitTyagiImage,
        //       details: "Details coming soon.",
        //     },
        //   ],
        // },
        // {
        //   dept: "Planning & Monitoring",
        //   chief: {
        //     id: 32,
        //     name: "Vivek Pratap Singh",
        //     role: "Chief - Planning & Monitoring",
        //     image: VivekPlanningImage,
        //     details: "Details coming soon.",
        //   },
        //   members: [
        //     {
        //       id: 33,
        //       name: "Vivek Pratap Singh",
        //       role: "Chief - Planning & Monitoring",
        //       image: VivekPlanningImage,
        //       details: "Details coming soon.",
        //     },
        //   ],
        // },
        // {
        //   dept: "MIS & Admin",
        //   chief: {
        //     id: 34,
        //     name: "Radha BL",
        //     role: "Head of MIS",
        //     image: RadhaImage,
        //     details: "Details coming soon.",
        //   },
        //   members: [
        //     {
        //       id: 35,
        //       name: "Radha BL",
        //       role: "Head of MIS",
        //       image: RadhaImage,
        //       details: "Details coming soon.",
        //     },
        //     {
        //       id: 36,
        //       name: "Chandrashekhar",
        //       role: "Head of Admin",
        //       image: ChandrashekarImage,
        //       details: "Details coming soon.",
        //     },
        //   ],
        // },
      ],
    },
    {
      title: "Board Committee",
      sections: [
        {
          dept: "Risk Department",
          chief: {
            id: 1,
            name: "Chief Credit Risk",
            role: "Head of Risk Department",
            image: "https://sonataindia.com/imgaes/Vivek.png",
          },
          members: [
            {
              id: 2,
              name: "Mr. Bramhanand",
              role: "Credit Risk & NPA",
              image: "https://sonataindia.com/imgaes/Vivek.png",
              details:
                "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
            },
            {
              id: 3,
              name: "Mr. Rajesh",
              role: "Senior Risk Manager",
              image: "https://sonataindia.com/imgaes/Vivek.png",
              details:
                "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
            },
            {
              id: 4,
              name: "Ms. Kavita",
              role: "Risk Analyst",
              image: "https://sonataindia.com/imgaes/Vivek.png",
              details:
                "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
            },
            {
              id: 5,
              name: "Ms. Kavita",
              role: "Risk Analyst",
              image: "https://sonataindia.com/imgaes/Vivek.png",
              details:
                "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
            },
          ],
        },

        {
          dept: "Finance Department",
          chief: {
            id: 5,
            name: "Chief Operational Risk",
            role: "Head of Finance Department",
            image: "https://sonataindia.com/imgaes/Vivek.png",
            details:
              "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
          },
          members: [
            {
              id: 6,
              name: "Mr. Ashok Sharma",
              role: "Chief Finance Officer",
              image: "https://sonataindia.com/imgaes/Vivek.png",
              details:
                "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
            },
            {
              id: 7,
              name: "Ms. Nidhi",
              role: "Accounts Manager",
              image: "https://sonataindia.com/imgaes/Vivek.png",
              details:
                "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
            },
          ],
        },

        {
          dept: "HR Department",
          chief: {
            id: 8,
            name: "Chief Compliance Risk",
            role: "Head of HR Department",
            image: "https://sonataindia.com/imgaes/Vivek.png",
            details:
              "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
          },
          members: [
            {
              id: 9,
              name: "Ms. Riya Kapoor",
              role: "Chief HR & Talent",
              image: "https://sonataindia.com/imgaes/Vivek.png",
              details:
                "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
            },
            {
              id: 10,
              name: "Mr. Sameer",
              role: "HR Executive",
              image: "https://sonataindia.com/imgaes/Vivek.png",
              details:
                "He is responsible for Strategic Business Planning Anup Singhand monitoring, product development and review of business operations. He has over 23 years of experience in Financial services.He is Chartered Financial Analyst from ICFAI and has done Masters in Business Administration (M.B.A.).",
            },
          ],
        },
      ],
    },
  ],
};
